/* eslint-disable camelcase */
import { put, call, select } from 'redux-saga/effects';
import { push } from 'redux-first-history';
import * as Sentry from '@sentry/browser';
import * as types from '../../constants/ActionTypes';
import { deleteToken } from '../../functions/tokenUtils';
import Api from '../../functions/Api';
import dataURLtoFile from '../../functions/dataURLtoFile';
import {
  clearHijackSession,
  isHijackSession,
  logoutV1,
} from '../../functions/authV1';
import { requestUser, resolveNextLoginPath } from './usersProfileRequestSaga';

export { requestUser, resolveNextLoginPath };

export function* updateProfile(action) {
  try {
    const { data: payload } = yield call(Api.put, 'profile/', {
      data: action.payload,
    });

    yield put({
      type: types.USER_UPDATE_SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({ type: types.NETWORK_ERROR, error });
    const { response: { errors } = {} } = error;
    let profileError = [];

    if (errors && errors.length) {
      profileError = Object.keys(errors[0].message).reduce(
        (arr, errorField) => {
          return [errorField, errors[0].message[errorField][0]];
        },
        []
      );
    }
    yield put({
      type: types.USER_UPDATE_FAILURE,
      error: profileError,
    });
  }
}

export function* changeLanguage(action) {
  try {
    const {
      data: { locale },
    } = yield call(Api.post, 'setlang/', {
      data: {
        language: action.locale,
      },
    });

    yield put({
      type: types.CHANGE_LANGUAGE_SUCCESS,
      locale,
    });
  } catch (error) {
    yield put({
      type: types.CHANGE_LANGUAGE_FAILURE,
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* fetchDefaultCountry(action) {
  try {
    const data = { name: 'Russia', code: 'RU' };

    yield put({
      type: types.FETCH_DEFAULT_COUNTRY_SUCCESS,
      payload: data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_DEFAULT_COUNTRY_FAILURE,
    });

    if (!action.silent) {
      yield put({ type: types.NETWORK_ERROR, error });
    }
  }
}

export function* unhijack() {
  try {
    yield call(Api.post, '/logas/release-hijack/', { notApiUrl: true });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
  clearHijackSession();
  deleteToken();
  window.location.href = '/admin/';
}

export function* handleLogout({ returnUrl, isHardRedirect }) {
  if (returnUrl) {
    if (isHardRedirect) window.location.href = returnUrl;
    else yield put(push(returnUrl));
    return;
  }
  if (isHijackSession()) {
    yield call(unhijack);
    return;
  }
  // User-initiated logout: drop the Studio and store sessions, then land on the store
  yield call(logoutV1);
  deleteToken();
  window.location.href = `${window.location.origin}/`;
}

export function* saveLoginProvider(action) {
  yield sessionStorage.setItem('loginProvider', action.provider);
}

export function* uploadAvatar(payload) {
  const userNickName = yield select((state) => state.user.nickname);
  const { image } = payload;
  const file = dataURLtoFile(image, `${userNickName}-avatar.png`);

  try {
    const formData = new FormData();
    formData.append('avatar', file);
    const {
      data: { avatar },
    } = yield call(Api.post, 'avatar/', {
      data: formData,
    });

    if (avatar) {
      yield put({
        type: types.UPLOAD_AVATAR_SUCCESS,
        avatar,
      });
    }
  } catch (error) {
    yield put({
      type: types.UPLOAD_AVATAR_FAILURE,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* handleAuth({ payload }) {
  const { id, email } = payload;

  // Set user scope
  yield call(() => {
    Sentry.withScope((scope) => {
      scope.setUser({ email, id });
    });
  });

  // Add bradcrumb with auth
  yield call(Sentry.addBreadcrumb, {
    category: 'auth',
    message: `Authenticated user (${email}, ${id})`,
    level: 'info',
  });
}
